import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowRight } from 'react-icons/fa';
import '../css/gtc-notification.css';

function GTCReminder(props: any) {
    const { id } = useParams();
    const navigate = useNavigate();

    const clickBack = async () => {
        navigate(-1)
    }   

    return (
        <div className="notification-container">
            <div className="notification-content">
                <p className="notification-message">
                    {props.reminder}
                </p>
                <button 
                    onClick={clickBack}
                    className="notification-action"
                >
                    {props.btnText || "My Channel"}
                    <FaArrowRight className="notification-icon" />
                </button>
            </div>
        </div>
    );
}

export default GTCReminder;